import React from 'react'

const Boxes = props => {
  return (
    <div
      style={{
        padding: '5px',
        background: '#fff',
        borderRadius: '20px',
      }}
    >
      {props.children}
    </div>
  )
}

Boxes.defaultProps = {}

export default Boxes
